import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 10h-16l5.5 -6","key":"svg-0"}],["path",{"d":"M4 14h16l-5.5 6","key":"svg-1"}]]

/**
 * IconTransfer
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJhbnNmZXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIwIDEwaC0xNmw1LjUgLTYiIC8+CiAgPHBhdGggZD0iTTQgMTRoMTZsLTUuNSA2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/transfer
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTransfer = createReactComponent('outline', 'transfer', 'Transfer', __iconNode);

export default IconTransfer;